


























































import StoreSubscriber from "@/utils/StoreSubscriber";

declare global {
  interface Window {
    google?: any;
  }
}

import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import PoiCollapsibleList from "@/components/ScoutingPlace/CollapsibleList.vue";
import { currentScoutingStore } from "@/store/typed";
import { ScoutingPlace } from "../../models";
import ScoutingPlaceSelectableItem from "@/components/ScoutingPlace/SelectableItem.vue";
import ScoutingArea, { ScoutingAreaFilter } from "@/models/ScoutingArea";
import ScoutingAreaMixin from "@/mixins/http/ScoutingAreaMixin";
import ScoutingAreaSelectableItem from "@/components/ScoutingArea/SelectableItem.vue";
import VContentLoading from "@/components/VContentLoading.vue";

@Component({
  components: {
    PoiCollapsibleList,
    ScoutingAreaSelectableItem,
    VContentLoading,
  },
})
export default class AreaSearch extends Mixins(ScoutingAreaMixin) {
  private results: ScoutingArea[] = [];
  selectedAreas: ScoutingArea[] = [];
  private pagination = null;
  private searching = false;
  private isLoading = false;

  async mounted() {
    this.isLoading = true;

    currentScoutingStore.$clearMarkers();
    currentScoutingStore.$setSearchScoutingAreas([]);
    await this.searchAreas();
    this.subscribe();

    this.isLoading = false;
  }

  subscribe() {
    StoreSubscriber.subscribe(
      "currentScouting/$updateSelectionScoutingArea",
      this.onScoutingAreaUpdateSelection.bind(this)
    );
  }

  onScoutingAreaUpdateSelection(area: ScoutingArea) {
    const scoutingArea = this.results.find((o) => o.id === area.id);
    if (scoutingArea) {
      this.checked(scoutingArea.id);
    }
  }

  checked(key: string) {
    const alreadySelected = this.scoutingAreas.find((o) => o.id === key);
    return (
      this.selectedAreas.map((o) => o.id).includes(key) || !!alreadySelected
    );
  }

  get searchScoutingAreas() {
    return currentScoutingStore.searchScoutingAreas;
  }

  get scoutingAreas() {
    return currentScoutingStore.scoutingAreas;
  }

  onChecked(checked: boolean, area: ScoutingArea) {
    area.highlighted = checked;
    if (checked) {
      this.selectedAreas.push(area);
    } else {
      const index = this.selectedAreas.findIndex((o) => o.id === area.id);
      if (index !== -1) {
        this.selectedAreas.splice(index, 1);
      }
    }
    currentScoutingStore.updateSearchScoutingArea(area);
  }

  get term() {
    return this.$route.params.term;
  }

  get granularityLabel() {
    return this.$route.params.granularityLabel;
  }

  back() {
    this.clearMapMarkers();
    this.$router.go(-1);
  }

  clearMapMarkers() {
    currentScoutingStore.setSearchScoutingPlaces([]);
    currentScoutingStore.clearMarkers();
  }

  async saveScoutingAreas() {
    if (this.selectedAreas.length) {
      this.isLoading = true;
      await currentScoutingStore.saveScoutingAreas(this.selectedAreas);
    }
    this.back();
  }

  async searchAreas() {
    const filter = new ScoutingAreaFilter();
    filter.term = this.$route.params.term;
    filter.granularity = this.$route.params.granularity;

    this.results = await this.search(filter);
    this.results.map((area: ScoutingArea) => {
      area.id = ScoutingArea.makeKey(area.sourceableId, area.sourceableType);
      area.highlighted = false;
    });

    currentScoutingStore.addSearchScoutingAreas(this.results);

    for (const area of this.searchScoutingAreas) {
      if (this.scoutingAreas.find((o) => o.id === area.id)) {
        this.onChecked(true, area);
      }
    }
  }
}
